import videoCreatorStyles from 'css/src/components/app/VideoCreator.module.scss';

import type { ReactNode } from 'react';
import React from 'react';

import { INFINITE_TOAST_DURATION, Toast } from 'js/src/components/common/Toast';
import { getMediaErrors } from 'js/src/data/media/media-selectors';
import { getSceneNumber } from 'js/src/luminary';
import { createLuminaryOperation } from 'js/src/luminary/luminary-hooks';

export const showMediaErrorOperation = createLuminaryOperation(({ getState, luminary }) => {
    const state = getState();
    const mediaErrors = getMediaErrors(state);

    if (mediaErrors === null || mediaErrors === undefined || mediaErrors.length === 0) {
        return;
    }
    const sceneIds = mediaErrors.map((errorDetails) => errorDetails['sceneId']);
    const scenes = sceneIds
        .map((id) => luminary.getSceneById(id))
        .filter((slide) => slide !== undefined); // Slides could be deleted in the meantime
    const sceneNumbers = scenes.map((scene) => {
        return getSceneNumber(state, scene);
    });

    const mediaErrorNodes: ReactNode[] = [];

    sceneNumbers.forEach((number, index) => {
        mediaErrorNodes.push(
            <span className="font-l5 font-l5--small--medium"> scene {number}</span>,
        );

        if (index === sceneNumbers.length - 2) {
            mediaErrorNodes.push(<span> and </span>);
        } else if (index !== sceneNumbers.length - 1) {
            mediaErrorNodes.push(<span>, </span>);
        }
    });

    const messageNode = (
        <p className={`m-l5-0 p-l5-0 ${videoCreatorStyles['media-error-toast']}`}>
            Media is no longer available from our providers in
            {mediaErrorNodes}.
            <br />
            Please select new media to save or publish this video.
        </p>
    );

    Toast.removeAll();
    Toast.error(messageNode, null, undefined, INFINITE_TOAST_DURATION);
});
